import { ApiURL, isProductionBuild } from 'core/constants/config';

export const getDevOrProdUrl = (devUrl: string, prodUrl: string) =>
	`${ApiURL}/${isProductionBuild ? prodUrl : devUrl}`;
